import Vue from "vue";
import App from "./App.vue";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import "@/assets/css/basic.css";
import "@/assets/css/layout.css";
import "@/assets/css/magnific-popup.css";
import "@/assets/css/animate.css";
import "@/assets/css/owl.carousel.css";
import "@/assets/css/gradient.css";


// import "@/assets/css/demo-color.css";
// import "@/assets/css/new-skin.css";

import "@/assets/css/new-skin.css";
import "@/assets/css/demo-color.css";
import "@/assets/css/dark.css";
import "@/assets/css/classic-skin.css";
import "@/assets/css/custom.css";


Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
